/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentType = {
    Prepayment: 'PREPAYMENT',
    Factoring: 'FACTORING',
    Other: 'OTHER'
} as const;
export type PaymentType = typeof PaymentType[keyof typeof PaymentType];


export function instanceOfPaymentType(value: any): boolean {
    for (const key in PaymentType) {
        if (Object.prototype.hasOwnProperty.call(PaymentType, key)) {
            if (PaymentType[key as keyof typeof PaymentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentTypeFromJSON(json: any): PaymentType {
    return PaymentTypeFromJSONTyped(json, false);
}

export function PaymentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentType {
    return json as PaymentType;
}

export function PaymentTypeToJSON(value?: PaymentType | null): any {
    return value as any;
}

export function PaymentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentType {
    return value as PaymentType;
}

